export enum ModelType {
    ANALYSIS = 'Analysis',
    ARTICLE = 'Article',
    DECISION = 'Decision',
    GLOSSARY_TERM = 'GlossaryTerm',
    LAW_TEXT = 'LawText',
    PUBLICATION_SHEET = 'PublicationSheet',
    STATISTIC = 'Statistic',
}
